module.exports = __webpack_public_path__ + "static/media/1-b.dd965f96.png";